<span class="goback">
    <a href="" class="btn btn-grey-bg" (click)="goBack($event)" >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0.224124 8.5555C-0.0747085 8.2456 -0.0747085 7.75479 0.224124 7.44489L6.39555 1.04488C6.70224 0.726837 7.20869 0.717629 7.52674 1.02432C7.84478 1.33101 7.85399 1.83746 7.5473 2.1555L2.68278 7.20019L15.2 7.20019C15.6418 7.20019 16 7.55837 16 8.00019C16 8.44202 15.6418 8.80019 15.2 8.80019L2.68278 8.80019L7.5473 13.8449C7.85399 14.1629 7.84478 14.6694 7.52674 14.9761C7.20869 15.2828 6.70224 15.2735 6.39555 14.9555L0.224124 8.5555Z"
                fill="black" />
        </svg> Go Back
    </a>
</span>
<div class="formwrapper card-bg-white">
    <div class="form-header">
        <h4 class="sec-title">Get your Customised Report</h4>
        <p class="sub-text">With an exclusive 20% off on your order</p>
    </div>

    <form class="form-innerwrap form-request" action="" method="post" [formGroup]="customReport">
        <div class="input-group ">
            <label class="form-label">Report Type<span class="sign">*</span></label>
            <select class="select-type-report form-select" id='report_type' name="report_type"
                formControlName=report_type>
                <option>Select</option>
                <option *ngFor="let item of reportTypeOptions" [value]="item.key">{{ item.label }}</option>
            </select>
            <div *ngIf="customReport.controls.report_type.touched && customReport.controls.report_type.invalid"
                class="invalid-feedback" role="alert">
                <span *ngIf="customReport?.controls.report_type?.errors?.required">Required Field</span>
            </div>
        </div>
        <div class="input-group">
            <label class="form-label">Industry Type<span class="sign">*</span></label>
            <select class="select-industry form-select" id='industry' name="industry" formControlName=industry>
                <option>Select</option>
                <option *ngFor="let item of industryOptions" [value]="item.key">{{ item.label }}</option>
            </select>
            <div *ngIf="customReport.controls.industry.touched && customReport.controls.industry.invalid"
                class="invalid-feedback" role="alert">
                <span *ngIf="customReport?.controls.industry?.errors?.required">Required Field</span>
            </div>
        </div>
        <div class="input-group textarea-group">
            <label class="form-label">Share Your Requirements With Us<span class="sign">*</span></label>
            <textarea class="form-control" id="requirement" name="requirement" formControlName=requirement rows="4"
                placeholder="Max length -250 Chars"></textarea>
            <div *ngIf="customReport.controls.requirement.touched && customReport.controls.requirement.invalid"
                class="invalid-feedback" role="alert">
                <span *ngIf="customReport?.controls.requirement?.errors?.required">Required Field</span>
                <span *ngIf="customReport?.controls.requirement?.errors?.maxlength">Requirements should be
                    {{customReport?.controls.requirement?.errors?.maxlength.requiredLength}} letters long.</span>
                <span *ngIf="customReport?.controls.requirement?.errors?.minlength">Requirements should be
                    {{customReport?.controls.requirement?.errors?.minlength.requiredLength}} minimum letters.</span>
            </div>
        </div>
        <div class="input-group">
            <label class="form-label">Expected Timeline for Delivery of Report<span class="sign">*</span></label>
            <select class="select-type-report form-select" id='timeline' name="timeline" formControlName=timeline>
                <option>Select</option>
                <option *ngFor="let item of timelineOptions" [value]=item.code>{{item.label}}</option>
            </select>
            <div *ngIf="customReport.controls.timeline.touched && customReport.controls.timeline.invalid"
                class="invalid-feedback" role="alert">
                <span *ngIf="customReport?.controls.timeline?.errors?.required">Required Field</span>
            </div>
        </div>
        <div class="input-group">
            <label class="form-label">Budget<span class="sign">*</span></label>
            <select class="form-select" id='budget' name="budget" formControlName=budget>
                <option>Select</option>
                <option *ngFor="let item of budgetOptions" [value]=item.code>{{item.label}}</option>
            </select>
            <div *ngIf="customReport.controls.budget.touched && customReport.controls.budget.invalid"
                class="invalid-feedback" role="alert">
                <span *ngIf="customReport?.controls.budget?.errors?.required">Required Field</span>
            </div>
        </div>
        <div class="input-group">
            <label class="form-label">Name<span class="sign">*</span></label>
            <input type="name" class="form-control" formControlName="name" id="name">
            <div *ngIf="customReport.controls.name.touched && customReport.controls.name.invalid"
                class="invalid-feedback" role="alert">
                <span *ngIf="customReport?.controls.name?.errors?.required">Required Field</span>
            </div>
        </div>
        <div class="input-group">
            <label class="form-label">Email<span class="sign">*</span></label>
            <input type="email" class="form-control" formControlName="email" id="email" placeholder="xyz@gmail.com">
            <div *ngIf="customReport.controls.email.touched && customReport.controls.email.invalid"
                class="invalid-feedback" role="alert">
                <span *ngIf="customReport?.controls.email?.errors?.required">Required Field</span>
            </div>
        </div>
        <div class="input-group">
            <label class="form-label">Contact<span class="sign">*</span></label>
            <input type="phone" class="form-control" formControlName="contact" id="contact"
                placeholder="+91 98XXXXXXXX">
            <div *ngIf="customReport.controls.contact.touched && customReport.controls.contact.invalid"
                class="invalid-feedback" role="alert">
                <span *ngIf="customReport?.controls.contact?.errors?.required">Required Field</span>
            </div>
        </div>

        <div class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="tc" value=truw id="tc" />
            I agree to the &nbsp;<a href="/terms-and-conditions" target="_blank">Terms & Conditions</a>
            <div *ngIf="
            customReport.controls['tc'].touched &&
            customReport.controls['tc'].invalid
        " class="alert alert-danger form-danger errors" role="alert">
                <span *ngIf="customReport?.controls.tc?.errors?.tc">Please agree Terms & Condition.</span>
            </div>
        </div>
        <div class="buttonwrap">
            <button type="submit" class="btn btn-dark-blue-bg" [disabled]="!customReport.valid || !customReport.dirty || !customReport.touched" (click)=submit()>
                <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M13.7733 0.326558C13.4693 0.0239599 12.9751 0.0239599 12.6711 0.326558L4.92593 8.03604L1.3289 4.45559C1.0249 4.15299 0.530657 4.15299 0.226657 4.45559C-0.0755523 4.75641 -0.0755525 5.24281 0.226657 5.54363L4.37481 9.67266C4.67881 9.97526 5.17305 9.97526 5.47705 9.67266L13.7733 1.4146C14.0756 1.11378 14.0756 0.627375 13.7733 0.326558Z"
                        fill="white" />
                </svg>
                Submit
            </button>
        </div>
    </form>
    <div class="note-text">
        <p>
            <span>Note:</span> For your convenience, TheKredible has introduced ‘Customized Report' where we deliver
            data as per your requirements. To be precise, our team will go through the entire process: checking
            possibilities of gathering data, the time required to complete the report, and pricing details and will
            revert to your query. After terms and conditions
            are discussed and a price is quoted, TheKredible team will then start working on the report providing the
            anticipated timeline.
        </p>
    </div>
</div>
